// extracted by mini-css-extract-plugin
export default {"navLang":"Nav_navLang__Dg5GT","nav":"Nav_nav__6d2Xm","ul":"Nav_ul__tDzmP","active":"Nav_active__9JtdD","forMenu":"Nav_forMenu__IAl1l","logo":"Nav_logo__sZQHY"};